import React from "react";

const IMG = {
  big:    "https://images.unsplash.com/photo-1642015927385-7789187dc913?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwyfHxlZGl0b3JpYWwlMjBmYXNoaW9uJTIwZGFyayUyMG1vb2R5fGVufDB8fHx8MTc4MTc4MTgzNHww&ixlib=rb-4.1.0&q=85",
  detail: "https://images.pexels.com/photos/19884483/pexels-photo-19884483.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  side:   "https://images.unsplash.com/photo-1779911915399-aeaaa1153847?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwzfHxlZGl0b3JpYWwlMjBmYXNoaW9uJTIwZGFyayUyMG1vb2R5fGVufDB8fHx8MTc4MTc4MTgzNHww&ixlib=rb-4.1.0&q=85",
  texture:"https://images.unsplash.com/photo-1599568723850-14196ee0f991?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwzfHx0cmFkaXRpb25hbCUyMHdvb2wlMjBsZWF0aGVyJTIwdGV4dHVyZXxlbnwwfHx8fDE3ODE3ODE4MzR8MA&ixlib=rb-4.1.0&q=85",
};

export const Lookbook = ({ t }) => {
  return (
    <section
      id="lookbook"
      data-testid="lookbook-section"
      className="px-6 md:px-12 lg:px-16 py-24 md:py-32 bg-[#110F0E]"
    >
      <div className="max-w-3xl mb-16 md:mb-24">
        <p className="overline mb-5">{t.lookbook.overline}</p>
        <h2 className="font-serif font-light text-[#F3EFE9] text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight mb-6">
          {t.lookbook.title}
        </h2>
        <p className="text-[#9D9287] text-base md:text-lg font-light leading-relaxed max-w-xl">
          {t.lookbook.sub}
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-8">
        <div className="md:col-span-8 md:row-span-2 editorial-img aspect-[4/5] md:aspect-auto md:min-h-[760px]">
          <img src={IMG.big} alt="Editorial portrait" loading="lazy" />
        </div>
        <div className="md:col-span-4 editorial-img aspect-[4/5] md:aspect-auto md:min-h-[370px]">
          <img src={IMG.detail} alt="Textile woven detail" loading="lazy" />
        </div>
        <div className="md:col-span-4 editorial-img aspect-[4/5] md:aspect-auto md:min-h-[370px]">
          <img src={IMG.side} alt="Fashion editorial" loading="lazy" />
        </div>
        <div className="md:col-span-12 editorial-img aspect-[21/9] mt-2">
          <img src={IMG.texture} alt="Brown textile close up" loading="lazy" />
        </div>
      </div>
    </section>
  );
};
